export interface CustomAudienceTermsAndConditions {
  accepted: boolean;
  endpoint: string;
}

export const exampleCustomAudienceTermsAndConditions: CustomAudienceTermsAndConditions = {
  accepted: false,
  endpoint: 'https://facebook.com/plz-accept',
};
